import { useTranslation } from 'react-i18next';
import { useGetEmailRule, useGetPasswordRule, useGetRequiredRule } from '@/hooks';
import { AuthFieldsNames } from '../helpers/types';

export const useSignInRules = () => {
  const { t } = useTranslation(['validations']);

  const emailRule = useGetEmailRule({ t });
  const requiredRule = useGetRequiredRule({ t });
  return {
    [AuthFieldsNames.EMAIL]: [emailRule, requiredRule],
    [AuthFieldsNames.PASSWORD]: [requiredRule],
  };
};

export const useForgotPasswordRules = () => {
  const { t } = useTranslation(['validations']);

  const emailRule = useGetEmailRule({ t });
  const requiredRule = useGetRequiredRule({ t });
  return {
    [AuthFieldsNames.EMAIL]: [emailRule, requiredRule],
  };
};

export const useResetPasswordRules = () => {
  const { t } = useTranslation(['validations']);

  const passwordRule = useGetPasswordRule({ t });
  const requiredRule = useGetRequiredRule({ t });
  return {
    [AuthFieldsNames.PASSWORD]: [requiredRule, passwordRule],
    [AuthFieldsNames.CONFIRM_PASSWORD]: [requiredRule, passwordRule],
  };
};
